import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup} from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select } from 'antd';
import { Lecture } from 'components/atoms'
import { useB2cNextCode } from 'hooks';

const QuotationItemModal = ({ 
    isOpen, 
    onClose}: PopupProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [lectureOpt, setLectureOpt] = useState<LectureCodeListDto>();
    const [groupList, setGroupList] = useState<NextLectureListDto[]>([]);
    const [groupOpt, setGroupOpt] = useState<NextLectureListDto>();
  /* ======================================================
  * hooks
  * ====================================================== */
    const { codeList } = useB2cNextCode({lecture_gid: Number(lectureOpt?lectureOpt.value:0) , lecture_cha: -1 })

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        if (!!groupOpt && !!lectureOpt) {
            const studentCnt = form.getFieldValue("studient_cnt");

            onClose?.(true, {
                title: `[${groupOpt.online_yn=='Y'?'온라인':'오프라인'}] ${groupOpt.lecture_name} (${groupOpt.start_date}~${groupOpt.end_date})`,
                num: studentCnt,
                price: (studentCnt * lectureOpt.price).toFixed(0),
                memo: form.getFieldValue("memo")
            });
        } else {
            onClose?.(false);            
        }
    };
    
    const onSelectLectur = (opt: LectureCodeListDto) => {
        setLectureOpt(opt)        
    }       
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!codeList) {
            const newCodeList = codeList.map(item=>{return {...item, label:`[${item.lecture_cha}차] ${item.start_date}~${item.end_date}`}})
            setGroupList(newCodeList)
        }
        
        form.setFieldsValue({group_srl: undefined});
    }, [codeList])   

    return (
    <>
        <ModalWrapper open={isOpen} onCancel={onCancel} width={420} title={'품목 등록'} closable>
            <Form
                form={form}
                name="QoutationItem"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="lecture_gid" label={'과정'} rules={[{ required: true, message: '' }]}>
                    <Lecture form={form} onSelected={onSelectLectur} disable={false}/>
                </Form.Item>   
                <Form.Item name="group_srl" label={'일정'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        placeholder="일정 선택" 
                        options={groupList} 
                        onSelect={(value, option) => {
                            setGroupOpt(option);
                        }} />                       
                </Form.Item>                              
                <Form.Item name="studient_cnt" label={'인원'} rules={[{ required: true, message: '' }]}>
                    <Input type="number" /> 
                </Form.Item>   
                <Form.Item name='memo' label={'메모'}>
                    <Input placeholder='메모를 입력하세요'/>   
                </Form.Item>                                   
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCancel} style={{marginRight: "5px"}}>닫기</Button>
                    </div>   
                    <div>
                        <Button htmlType="submit" type="primary">{'등록'}</Button>
                    </div>
                </ButtonGroup>                
            </Form>            
        </ModalWrapper>  
    </>
    )    
};

export default React.memo(QuotationItemModal);    